module.exports = __webpack_public_path__ + "static/img/twjd-sdl4.519b2dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdl4.png
// module id = 849
// module chunks = 0